<!--
  Dynamic size is disabled because of tailwindcss behavior.
-->
<div class="flex justify-center items-center">
  <div class="animate-spin rounded-full border-t-2 border-b-2" [ngClass]="{
    'h-6 w-6': size === 'small',
    'h-10 w-10': size === 'medium',
    'h-14 w-14': size === 'large',
    'border-black dark:border-white': color === 'primary',
  }"></div>
</div>
